CustomEase.create('menuBlurEase', ' 0.17, 0, 0.83, 1');
CustomEase.create('menuModelScaleEase', ' 0.4, 0, 0.2, 1');
const menu = header.find('.header-menu');
const menuBG = menu.find('.header-menu-bg');
const menuContent = menu.find('.footer-content');
const menuModel = menu.find('.model-placer');
const menuBtn = menu.find('.button-parent');
const menuGroups = menu.find('.footer-group');
const leftContentItems = menu.find('.left-content-item');
const navItems = $('header > .header-navs .nav-item-link-bg');
const mobileNavItemsParent = menu.find('.footer-navs-mobile');
const mobileNavItems = menu.find('.mobile-nav-parent');
const menuModelImage = menu.find('.header-model-image');
const menuNavBtns = header.find('.nav-item.link:has(.nav-item-link[href$="#menu"])');

let isMenuNavItemsChanged = false;
let menuScene;
let menuOutTL;
let menuInTL;
let drawMenuFrame;

const menuIconGap = () => (isDesktop() ? 0.313 : isTablet() ? 0.521 : 1.111);

const addNavIcon = () => {
  const menuIcon = $(`
    <div class="nav-item-link-icon-parent">
      <div class="nav-item-link-icon">
        <div class="nav-item-link-icon-line" id="nav-item-link-icon-line-first" style="transform: translateY(-${
          menuIconGap() / 2
        }vw)"></div>
        <div class="nav-item-link-icon-line" id="nav-item-link-icon-line-second" style="transform: translateY(${
          menuIconGap() / 2
        }vw)"></div>
      </div>
    </div`);

  menuNavBtns.each(function () {
    const menuLink = $(this).find('.nav-item-link');
    const menuHoverLink = $(this).find('.nav-item-link-text-hover');
    gsap.set([menuLink, menuHoverLink], {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '0.625vw',
    });
    menuHoverLink.append(menuIcon.clone());
    menuLink.append(menuIcon.clone());
  });
};

const menuSet = () => {
  !isDesktop() ? mobileNavControl(menu) : false;
  addBtnHover(menuBtn);
  gsap.set(menu, { display: 'none' });
};

const resetElementAnimations = () => {
  gsap.killTweensOf([menu, menuBG, menuContent, menuModel, menuBtn, menuGroups]);
};

const toggleHeaderNavs = (direction) => {
  const headerNav = $('header .nav-menu.right .nav-item.link');
  const headerNavBgFirst = headerNav.find('.nav-item-link-bg-first');
  const headerNavBgSecond = headerNav.find('.nav-item-link-bg-second');
  const headerLogoOverflows = $('header').find('.logo-full-overflow');
  const headerNavBgFirstOffset = gsap.getProperty(headerNavBgFirst.get(0), 'y');
  if ((headerNavBgFirstOffset != 0 && !isMenuNavItemsChanged) || isMenuNavItemsChanged) {
    isMenuNavItemsChanged = !isMenuNavItemsChanged;
    gsap.set(headerNavBgFirst, { y: direction ? '0' : '-101%' });
    gsap.set(headerNavBgSecond, { y: direction ? '101%' : '0' });
    gsap.set(headerLogoOverflows, {
      height: (index) => (index == 0 ? (direction ? '100%' : '0') : direction ? '0' : '100%'),
    });
  }
};

const menuNavAnimation = (direction) => {
  const menuIcon = $('.nav-item-link-icon');
  const firstLine = menuIcon.find('#nav-item-link-icon-line-first');
  const secondLine = menuIcon.find('#nav-item-link-icon-line-second');

  gsap.to(firstLine, {
    y: () => (direction ? 0 : `-${menuIconGap() / 2}vw`),
    delay: direction ? 0 : 0.33,
    duration: 0.16,
    overwrite: 'auto',
  });
  gsap.to(secondLine, {
    y: () => (direction ? 0 : `${menuIconGap() / 2}vw`),
    delay: direction ? 0 : 0.33,
    duration: 0.16,
    overwrite: 'auto',
  });
  gsap.to(firstLine, {
    rotate: direction ? 45 : 0,
    transformOrigin: '50% 50%',
    duration: 0.33,
    delay: direction ? 0.16 : 0,
    overwrite: 'auto',
  });
  gsap.to(secondLine, {
    rotate: direction ? -45 : 0,
    transformOrigin: '50% 50%',
    duration: 0.33,
    delay: direction ? 0.16 : 0,
    overwrite: 'auto',
  });
};

const menuInAnimation = () => {
  const menuInAnimationTL = gsap.timeline({
    paused: true,
    onStart: () => {
      gsap.set(menu, { display: 'flex' });
      //gsap.set(menuModel, { clearProps: 'transform,scale,y' });
    },
    onComplete: () => {
      gsap.set(menu, { pointerEvents: 'auto' });
      isMenuOpened = true;
    },
  });

  menuInAnimationTL.add(gsap.set(menuContent, { y: 0, opacity: 1 }), 0);
  menuInAnimationTL.add(gsap.set(menuModel, { y: 0, scale: 0, opacity: 1 }), 0);
  menuInAnimationTL.add(gsap.set(mobileNavItems, { y: '6.389vw', opacity: 0 }), 0);
  menuInAnimationTL.add(
    gsap.fromTo(
      menuBG,
      {
        opacity: 0,
        backgroundColor: 'transparent',
      },
      {
        opacity: 1,
        backgroundColor: 'rgba(62, 88, 131, 0.3)',
        duration: 0.67,
        ease: 'menuBlurEase',
      }
    ),
    0
  );
  menuInAnimationTL.add(
    gsap.fromTo(
      menuModel,
      {
        y: 0,
        scale: 0,
      },
      {
        y: 0,
        scale: 1,
        duration: 1.17,
        ease: 'menuModelScaleEase',
      }
    ),
    0.33
  );

  menuInAnimationTL.add(elementInAnimationYWOpacity(leftContentItems, '3.75vw', 0, 1, 0.83, 0.5, 0.33, 0.1).play(), 0.17);
  menuInAnimationTL.add(elementInAnimationYWOpacity(menuGroups, '3.75vw', 0, 1, 0.83, 0.5, 0.33, 0.1).play(), 0.27);
  menuInAnimationTL.add(elementInAnimationYWOpacity(mobileNavItems, '6.389vw', 0, 1, 0.83, 0.5, 0.33, 0.033).play(), 0.17);

  return menuInAnimationTL;
};

const menuOutAnimation = () => {
  const menuOutAnimationTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      gsap.set(menu, { pointerEvents: 'none' });
      gsap.set(menu, { display: 'none' });
      isMenuOpened = false;
    },
  });

  menuOutAnimationTL.add(elementOutAnimationYWOpacity(menuContent, '7.5vw', 0.6, 0.6).play(), 0);
  menuOutAnimationTL.add(elementOutAnimationYWOpacity(leftContentItems, '3.75vw', 0.42, 0.25, 0, 0.05).play(), 0.2);
  menuOutAnimationTL.add(elementOutAnimationYWOpacity(menuGroups, '2.5vw', 0.38, 0.23, 0, 0.05, 'end').play(), 0);
  menuOutAnimationTL.add(
    gsap.fromTo(
      menuModel,
      {
        scale: 1,
      },
      {
        scale: 0,
        duration: 0.83,
        ease: 'menuModelScaleEase',
      }
    ),
    0
  );
  menuOutAnimationTL.add(
    gsap.fromTo(
      menuModel,
      {
        y: 0,
      },
      {
        y: '45vw',
        duration: 0.83,
        ease: 'menuModelScaleEase',
      }
    ),
    0.13
  );
  menuOutAnimationTL.add(
    gsap.fromTo(
      menuModel,
      {
        opacity: 1,
      },
      {
        opacity: 0,
        duration: 0.33,
        ease: 'menuBlurEase',
      }
    ),
    0.17
  );
  menuOutAnimationTL.add(
    gsap.fromTo(
      menuBG,
      {
        opacity: 1,
        backgroundColor: 'rgba(62, 88, 131, 0.3)',
      },
      {
        opacity: 0,
        backgroundColor: 'transparent',
        duration: 0.67,
        ease: 'menuBlurEase',
      }
    ),
    0.17
  );

  return menuOutAnimationTL;
};

const addHeaderMenuModel = () => {
  const modelAttachments = {
    'strap loop': {
      isVisible: true,
      nodesNames: ['activ-strap-loop'],
      changeDisable: [],
      nodes: [],
    },
    'Rounded Pad': {
      isVisible: false,
      nodesNames: ['pad-top-cover', 'pad-locker', 'pad-lock-cover', 'pad-lock-circle'],
      changeDisable: ['Arched Pad'],
      nodes: [],
    },
    'Arched Pad': {
      isVisible: false,
      nodesNames: ['archer-pad-lock', 'archer-pad-inner-cover', 'archer-pad-cover'],
      changeDisable: ['Rounded Pad', 'Comfort Pack'],
      nodes: [],
    },
    'Comfort Pack': {
      isVisible: false,
      nodesNames: ['archer-pad-comfort'],
      changeDisable: ['Arched Pad'],
      nodes: [],
    },
  };
  const modelViewer = header.find('model-viewer');
  const modelViewerControls = undefined;
  menuModelImage.css('display', 'none');
  modelViewer.attr('src', 'https://cdn.jsdelivr.net/gh/intredd/af_images@main/3dmodel/device-3d.glb');

  addModelViewer(modelAttachments, modelViewer, modelViewerControls)
    .then((scene) => {
      menuScene = scene;
      scene.model.rotation.set(baseRotation.x + Math.PI / 9, baseRotation.y, baseRotation.z - Math.PI / 10);

      menuInTL.add(
        gsap.fromTo(
          scene.model.rotation,
          {
            z: baseRotation.z - Math.PI / 10,
          },
          {
            z: baseRotation.z - Math.PI / 10 - Math.PI * 2,
            duration: 1.2,
            ease: 'menuModelScaleEase',
            onUpdate: () => {
              scene.queueRender();
            },
          }
        ),
        0.33
      );
    })
    .catch((err) => {
      console.error('Ошибка при загрузке модели', err);
    });
};

const toggleMenuBtn = (menuBtn, menuBtnLink, menuBtnHoverText, menuOpened) => {
  if (!isDesktop()) {
    const menuIcons = menuBtn.find('.nav-item-icon');
    const displayValues = menuOpened ? ['block', 'none'] : ['none', 'block'];

    gsap.set(menuIcons, {
      display: (index) => displayValues[index],
    });
  }
};

let toggleMenu;

const menuControl = () => {
  const menuBtn = $('.nav-item.link:has(.nav-item-link[href$="#menu"])');
  const menuBtnLink = menuBtn.find('.nav-item-link[href$="#menu"]');
  const menuBtnHoverText = menuBtn.find('.nav-item-link-text-hover');

  toggleMenu = () => {
    toggleMenuBtn(menuBtn, menuBtnLink, menuBtnHoverText, isMenuOpened);
    if (isMenuOpened) {
      lenis.start();
      menuNavAnimation(false);
      toggleHeaderNavs(false);
      menuInTL.pause();
      menuOutTL.restart();
    } else {
      lenis.stop();
      menuNavAnimation(true);
      toggleHeaderNavs(true);
      menuOutTL.pause();
      menuInTL.invalidate().restart();
    }
    isMenuOpened = !isMenuOpened;
  };

  menuBtn.on('click', () => {
    
    if (isNotificationOpened && !isMenuOpened) {
      notificationTL.reverse();
      gsap.delayedCall(1, () => toggleMenu());
    } else if (isCartNotificationOpened && !isMenuOpened) {
      cartNotificationTL.reverse();
      gsap.delayedCall(1, () => toggleMenu());
    } else if (isCartOpened && !isNotificationOpened) {
      cartTL.reverse();
      gsap.delayedCall(1, () => toggleMenu());
    } else {
      toggleMenu();
    }
  });
};


const addMenuSequenceAnimation = () => {
  let obj = { frame: 0 };
  menuInTL.add(
    gsap.fromTo(
      obj,
      {
        frame: 0,
      },
      {
        frame: 70,
        duration: 1.17,
        ease: 'menuModelScaleEase',
        onUpdate: () => {
          drawMenuFrame(Math.round(obj.frame));
        },
      }
    ),
    0.33
  );
};

$(window).on('deviceChange', function () {
  if (menuOutTL) menuOutTL.kill();
  if (menuInTL) menuInTL.kill();
  menuOutTL = menuOutAnimation();
  menuInTL = menuInAnimation();
  mobileNavControl(menu);
  if (isMenuOpened) {
    isMenuOpened = !isMenuOpened;
    toggleMenu();
  }
  addMenuSequenceAnimation();
});

const addMenuWebGLSequence = () => {
  if (!isLowEndDevice) {
    ({ drawFrame: drawMenuFrame } = initWebGLSequence(
      'model-sequence',
      70,
      'https://cdn.jsdelivr.net/gh/eugene-activbody/activeforce_data/menu_scene/scene_frame_',
      'avif',
      5
    ));
    gsap.set(menuModel, {height: '1dvh'});
    //addHeaderMenuModel();
  }
}

const initMenu = () => {
  runTasks([
    addMenuWebGLSequence,
    addNavIcon,
    /*menuSet,*/
    () => menuOutTL = menuOutAnimation(),
    () => menuInTL = menuInAnimation(),
    addMenuSequenceAnimation,
    menuControl,
  ])
  
  /*
  menuOutTL = menuOutAnimation(),
  menuInTL = menuInAnimation(),
  addMenuSequenceAnimation();
  menuControl();
  */
}


$(window).on('load', () => {
  initMenu();
  menuSet()
});
